<!--
 * @Author: ckj kaijun.cui@biz-united.com.cn
 * @Date: 2025-11-28 10:35:27
 * @LastEditors: Tang Hao
 * @LastEditTime: 2025-12-23 11:45:55
 * @Description:
-->
<script>
import TablePage from '@/found/components/table_page';

export default {
  extends: TablePage,
  props: {
    formConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
  },
  data() {
    return {
      requestType: 'POST',
    };
  },
  mounted() {
    const { row } = this.formConfig;
    this.params = {
      ...this.params,
      checkCode: row.checkCode,
    };
    this.getConfigList('different_table');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'reconciliation') {
        this.formConfig = {
          ...this.formConfig,
          code: 'add',
          row,
        };
        this.modalConfig.title = '对账';
        this.openModal();
      }
      if (val.code === 'view_differences') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = '查看差异项';
        this.openFull();
      }
    },
  },
};
</script>
